export default {
  namespaced: true,
  state: {
    // 导航标题
    navTile: [],
    townName:"孙桥镇"
  },
  mutations: {
    setnavTile(state, val) {
      state.navTile = val
    },
  }
}